import React from "react";
import ReactJson from 'react-json-view';
import get from 'lodash/get';

const JSONField = (props) => {
	const { record, source, label, onAdd, onEdit } = props;
	const value = get(record, source);
    
	return (
		<>
			<p className="grey">{label}:</p>
			<ReactJson src={value} name={false} onAdd={onAdd} onEdit={onEdit} />
		</>
	);
};

export default JSONField;
